export enum FilesMutations {
  SET_FILELIST = "SET_FILELIST",
  SET_FILE_URL = "SET_FILE_URL",
}
